<template>
  <ul class="validation">
    <li v-for="message in [].concat(message)" :key="message">
      <AlertIcon />
      {{ message }}
    </li>
  </ul>
</template>

<script>
import AlertIcon from '@/components/icons/AlertIcon'
/**
 * バリデーション表示
 */
export default {
  name: 'Validation',
  components: {
    AlertIcon,
  },
  props: {
    /** メッセージ */
    message: [String, Array],
  },
}
</script>

<style lang="postcss" scoped>
.validation {
  color: var(--pure-red);
  list-style-type: none;

  li {
    align-items: center;
    display: flex;
    font-size: 13px;
    line-height: 1;
    word-break: keep-all;
  }
}

svg {
  fill: var(--pure-red);
  height: 16px;
  margin-right: 4px;
  min-width: 16px;
  vertical-align: sub;
  width: 16px;
}
</style>
